// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Webflow: "an update is ready, publish to finish" (WebflowPublishPending.js).
   Floats under the header so the page below never moves. */
.wf-publish-pending {
  position: fixed;
  top: calc(var(--app-header-height, 56px) + 16px);
  right: 24px;
  z-index: 1200;
  width: min(420px, calc(100vw - 32px));
  max-height: calc(100vh - var(--app-header-height, 56px) - 32px);
  overflow-y: auto;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(43, 33, 64, 0.16);
  animation: wf-publish-pending-in 220ms ease-out;
}
.wf-publish-pending .wf-publish-notice {
  margin: 0;
  max-width: none;
  padding-right: 40px;
}
.wf-publish-pending .wf-publish-notice + .wf-publish-notice {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-top: 0;
}
.wf-publish-pending__close {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #6b5f85;
  cursor: pointer;
}
.wf-publish-pending__close:hover {
  background: rgba(86, 22, 234, 0.08);
  color: #2b2140;
}
@keyframes wf-publish-pending-in {
  from { opacity: 0; transform: translateY(-6px); }
  to { opacity: 1; transform: none; }
}
@media (max-width: 600px) {
  .wf-publish-pending {
    right: 16px;
    top: calc(var(--app-header-height, 56px) + 8px);
  }
}
@media (prefers-reduced-motion: reduce) {
  .wf-publish-pending { animation: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/WebflowPublishPending.css"],"names":[],"mappings":"AAAA;2DAC2D;AAC3D;EACE,eAAe;EACf,gDAAgD;EAChD,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,+DAA+D;EAC/D,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;EAC9C,+CAA+C;AACjD;AACA;EACE,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;AACA;EACE,mCAAmC;EACnC,cAAc;AAChB;AACA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,eAAe,EAAE;AACpC;AACA;EACE;IACE,WAAW;IACX,+CAA+C;EACjD;AACF;AACA;EACE,sBAAsB,eAAe,EAAE;AACzC","sourcesContent":["/* Webflow: \"an update is ready, publish to finish\" (WebflowPublishPending.js).\n   Floats under the header so the page below never moves. */\n.wf-publish-pending {\n  position: fixed;\n  top: calc(var(--app-header-height, 56px) + 16px);\n  right: 24px;\n  z-index: 1200;\n  width: min(420px, calc(100vw - 32px));\n  max-height: calc(100vh - var(--app-header-height, 56px) - 32px);\n  overflow-y: auto;\n  border-radius: 10px;\n  box-shadow: 0 10px 30px rgba(43, 33, 64, 0.16);\n  animation: wf-publish-pending-in 220ms ease-out;\n}\n.wf-publish-pending .wf-publish-notice {\n  margin: 0;\n  max-width: none;\n  padding-right: 40px;\n}\n.wf-publish-pending .wf-publish-notice + .wf-publish-notice {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  border-top: 0;\n}\n.wf-publish-pending__close {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  z-index: 1;\n  width: 28px;\n  height: 28px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: #6b5f85;\n  cursor: pointer;\n}\n.wf-publish-pending__close:hover {\n  background: rgba(86, 22, 234, 0.08);\n  color: #2b2140;\n}\n@keyframes wf-publish-pending-in {\n  from { opacity: 0; transform: translateY(-6px); }\n  to { opacity: 1; transform: none; }\n}\n@media (max-width: 600px) {\n  .wf-publish-pending {\n    right: 16px;\n    top: calc(var(--app-header-height, 56px) + 8px);\n  }\n}\n@media (prefers-reduced-motion: reduce) {\n  .wf-publish-pending { animation: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
